<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-number [value]="themeOptions.options().gauge.pointerOptions.stroke_width" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="5" [step]="1"></app-number>
  </div>
</app-theme-option>